import { Column } from "@tanstack/react-table";

import { DRAG_HANDLE_WIDTH_PX } from "ui/data-grid/components/table-view/use-table-layout";

type TableColumnsGroupProps<T> = {
  isDraggable: boolean;
  renderSpacer: boolean;
  leftColumns: Column<T, unknown>[];
  rightColumns: Column<T, unknown>[];
  getLeftColWidth: (column: Column<T, unknown>) => string;
  getRightColWidth: (column: Column<T, unknown>) => string;
};

export const TableColumnsGroup = <T,>({
  isDraggable,
  renderSpacer,
  leftColumns,
  rightColumns,
  getLeftColWidth,
  getRightColWidth,
}: TableColumnsGroupProps<T>) => (
  <colgroup>
    {isDraggable && <col style={{ width: `${DRAG_HANDLE_WIDTH_PX}px` }} />}

    {leftColumns.map((column) => (
      <col key={column.id} style={{ width: getLeftColWidth(column) }} />
    ))}

    {renderSpacer && <col />}

    {rightColumns.map((column) => (
      <col key={column.id} style={{ width: getRightColWidth(column) }} />
    ))}
  </colgroup>
);
